module.exports = __webpack_public_path__ + "assets/icon-conductor-tape10.316a1e5c.svg";